module.exports = __webpack_public_path__ + "media/escudos/logo_reniec-b29d8e74.png";